module.exports = __webpack_public_path__ + "static/assets/hello_image.png";